import {
  AppConstant,
  MODULE_NAME,
  VALIDATOR_PATTERNS,
} from 'src/app/helper/class/app-constant';
import { formTransform } from 'src/app/helper/class/form-helper';
import { formBuilderData } from 'src/app/helper/interface/response';
import { STAFF_OFFICE_FORM } from '../../staff/helper/staff_form';

export class Config {
  //   STATUS
}
export const HOME_FORM: formBuilderData[] = [
  {
    colName: 'home_no',
    title: 'HOMES/Project No',
    validator: [
      { name: 'required', error: 'Home/Project Number should not be blank' },
    ],
  },
  {
    colName: 'homeName',
    title: 'HOMES/Project Name',
    validator: [{ name: 'required', error: 'Home Name should not be blank' }],
  },
  {
    colName: 'type',
    title: 'Category',
    type: 'select',
    apiTblName: 'home_type',
    selectKeyName: 'home_typeName',
    selectPrimaryKey: 'id',
    validator: [
      { name: 'required', error: 'Home Category should not be blank' },
    ],
  },
  {
    colName: 'building_agreement',
    title: 'Building Agreement Type',
    type: 'select',
    apiTblName: 'building_agreement',
    selectKeyName: 'building_agreementName',
    selectPrimaryKey: 'id',
    defaultValue: '',
    validator: [{ name: 'required', error: 'Agreement should not be blank' }],
  },
  {
    colName: 'mobile_no',
    validator: [
      {
        name: 'pattern',
        funValue: VALIDATOR_PATTERNS.MOBILE,
        error: 'Mobile NUmber should be valid',
      },
      { name: 'required', error: 'Mobile Number is required' },
    ],
  },
  {
    colName: 'mobile_no_alternative',
    validator: [
      {
        name: 'pattern',
        funValue: VALIDATOR_PATTERNS.MOBILE,
        error: 'Mobile NUmber should be valid',
      },
    ],
  },
  {
    colName: 'email_id',
    validator: [
      {
        name: 'pattern',
        funValue: VALIDATOR_PATTERNS.EMAIL,
        error: 'Email should be valid',
      },
    ],
  },

  {
    colName: 'sponsor_type',
    type: 'select',
    data: [
      { id: 1, name: 'Individual' },
      { id: 2, name: 'Group' },
    ],
    selectKeyName: 'name',
    selectPrimaryKey: 'id',
    defaultValue: 1,
    validator: [{ name: 'required', error: 'Type should not be blank' }],
  },
  {
    colName: 'home_start_year',
    title: 'From Start On ',
    type: 'DATE',
    yearNavigator: true,
    monthNavigator: true,
    placeholder: 'Since from',
    dateRange: AppConstant.DEFAULT_DATE_RANGE,
    validator: [{ name: 'required', error: 'Date is Required' }],
  },
  {
    colName: 'distance_school',
    title: 'Distance Of primary school from Home',
    inputKeyFilter: 'num',
    icon_append: { text: 'Km', category: 'APPEND' },
  },
  {
    colName: 'distance_high_school',
    title: 'Distance of High/ Secondary School from Home',
    inputKeyFilter: 'num',
    icon_append: { text: 'Km', category: 'APPEND' },
  },
  {
    colName: 'distance_anganwadi',
    title: 'Distance of Anganwadi from Home',
    inputKeyFilter: 'num',
    icon_append: { text: 'Km', category: 'APPEND' },
  },
  {
    colName: 'annual_budget',
  },
];

export const HOME_OFFICE_FORM: formBuilderData[] = [
  {
    groupTitle: 'Office Details',
    colName: 'no_of_wardern',
    title: 'No Of Warden',
    validator: [
      {
        name: 'pattern',
        funValue: VALIDATOR_PATTERNS.NUMBER,
        error: 'Only Number should Allowed',
      },
    ],
  },
  {
    colName: 'no_of_cook',
    title: 'No Of cook',
    validator: [
      {
        name: 'pattern',
        funValue: VALIDATOR_PATTERNS.NUMBER,
        error: 'Only Number should Allowed',
      },
    ],
  },
  {
    colName: 'no_of_social_worker',
    title: 'No Of Social Worker',
    validator: [
      {
        name: 'pattern',
        funValue: VALIDATOR_PATTERNS.NUMBER,
        error: 'Only Number should Allowed',
      },
    ],
  },
  {
    colName: 'no_of_helper',
    title: 'No Of Helper',
    validator: [
      {
        name: 'pattern',
        funValue: VALIDATOR_PATTERNS.NUMBER,
        error: 'Only Number should Allowed',
      },
    ],
  },
  {
    colName: 'region',
    title: 'Region',
    type: 'select',
    apiTblName: 'region',
    selectKeyName: 'regionName',
    selectPrimaryKey: 'id',
    defaultValue: '',
    event: {
      name: 'change',
      apiTblName: 'zone',
      valueAssign: 'zone',
    },
    validator: [{ name: 'required', error: 'Region should not be blank' }],
  },
  {
    colName: 'zone',
    selectKeyName: 'zoneName',
    selectPrimaryKey: 'id',
    defaultValue: '',
    type: 'select',
    title: 'Zone Name',
    event: {
      name: 'change',
      apiTblName: 'field',
      valueAssign: 'field',
      apiFunName: 'getFieldByZone',
    },
    validator: [{ name: 'required', error: 'Zone Name should not be blank' }],
  },
  {
    colName: 'field',
    selectKeyName: 'fieldName',
    selectPrimaryKey: 'id',
    defaultValue: '',
    type: 'select',
    title: 'Field Name',
    event: { name: 'change', isCallback: true },
    validator: [{ name: 'required', error: 'Field Name should not be blank' }],
  },
  {
    colName: 'allow_mk',
    title: 'Allow Mk Child On home ? ',
    type: 'checkbox',
    selectKeyName: 'allow_mk_statusName',
    selectPrimaryKey: 'id',
    event: { isCallback: true, name: 'change' },
    data: [{ allow_mk_statusName: 'Yes', id: 1 }],
    col_size: 12,
  },
  {
    colName: 'remarks',
  },
  {
    colName: 'comment',
    type: 'TEXTAREA',
  },
];
const formStatusData = [
  { statusName: 'Published', id: 1 },
  { statusName: 'UnPublished', id: 2 },
];
export const FORMS_TEMP_FORM: formBuilderData[] = [
  {
    colName: 'id',
    hidden: true,
    visible: false,
  },
  {
    colName: 'formsName',
    validator: [{ name: 'required' }],
  },
  {
    colName: 'form_id',
    hidden: true,
  },
  {
    colName: 'form_category_fk_id',
    type: 'select',
    title: 'Category Name',
    selectKeyName: 'form_categoryName',
    validator: [{ name: 'required' }],
    apiTblName: 'form_category',
  },
  {
    colName: 'cc',
    visible: false,
    validator: [{ name: 'pattern', funValue: VALIDATOR_PATTERNS.EMAIL }],
    type: 'chips',
  },
  {
    colName: 'is_campus',
    type: 'checkbox',
    selectKeyName: 'is_campusName',
    selectPrimaryKey: 'id',
    data: [{ is_campusName: 'Yes', id: true }],
  },
  { colName: 'description', title: 'Info', type: 'editor', visible: false },
  {
    groupTitle: 'Permission',
    colName: 'permission_type',
    selectKeyName: 'permission_typeName',
    event: { isCallback: true, name: 'change' },
    type: 'select',
    data: [
      { permission_typeName: 'staff', id: 'staff' },
      { permission_typeName: 'Office', id: 'office' },
      { permission_typeName: 'Both', id: 'both' },
    ],
  },
  {
    colName: 'status',
    type: 'select',
    colType: 'DROPDOWN',
    data: formStatusData,
    selectKeyName: 'statusName',
    filterCol: {
      data: formStatusData,
      selectKeyName: 'statusName',
      selectPrimaryKey: 'id',
      type: 'DROPDOWN',
    },
  },
  {
    colName: 'updated_at',
    title: 'Updated On',
    hidden: true,
    colType: 'DATETIME',
    filter: false,
  },
];
export const NOTIFICATION_TEMP_FORM: formBuilderData[] = [
  {
    colName: 'notification_templateName',
    readonly: true,
    validator: [{ name: 'required' }],
  },
  {
    colName: 'template_type',
    readonly: true,
    validator: [{ name: 'required' }],
    visible: false,
  },
  {
    colName: 'id',
    visible: false,
    hidden: true,
    isPrimary: true,
  },
  {
    colName: 'gateways_fk_id',
    title: 'Gateway',
    type: 'select',
    apiTblName: 'notification_gateways',
    selectKeyName: 'provider_name',
    validator: [{ name: 'required' }],
  },
  {
    colName: 'subject',
    validator: [{ name: 'required' }],
  },
  {
    colName: 'cc',
    visible: false,
    type: 'chips',
    validator: [{ name: 'pattern',funValue:VALIDATOR_PATTERNS.EMAIL }],
  },
  {
    colName: 'bcc',
    visible: false,
    type: 'chips',
    validator: [{ name: 'pattern',funValue:VALIDATOR_PATTERNS.EMAIL }],
  },
  {
    colName: 'allow_to_sent',
    selectKeyName: 'allow_sent',
    type: 'checkbox',
    data: [{ allow_sent: 'Yes', id: '1' }],
  },
  {
    colName: 'created_at',
    title: 'Created On',
    colType: 'DATE',
    hidden: true,
    filter: false,
  },
   {
    colName: 'updated_at',
    title: 'Updated On',
    colType: 'DATE',
    hidden: true,
    filter: false,
  },
];

export const NOTIFICATION_CONFIG: formBuilderData[] = [
  {
    colName: 'gateway_type',
    data: [
      { gateway_type: 'sms' },
      { gateway_type: 'email' },
      { gateway_type: 'whatsapp' },
    ],
    type: 'select',
    selectKeyName: 'gateway_type',
    selectPrimaryKey: 'gateway_type',
  },
  { colName: 'provider_name', validator: [{ name: 'required' }] },
  {
    colName: 'host',
    validator: [{ name: 'required' }],
  },
  {
    colName: 'username',
    validator: [
      { name: 'required' },
      // { name: 'pattern', funValue: VALIDATOR_PATTERNS.EMAIL },
    ],
  },
  {
    colName: 'password',
    validator: [{ name: 'required' }],
    visible: false,
  },
  { colName: 'sender_name', validator: [{ name: 'required' }] },
  {
    colName: 'sender_id',
  },
  {
    colName: 'api_key',
    visible: false,
  },
  {
    colName: 'token',
    visible: false,
  },
  {
    colName: 'port',
    inputKeyFilter: 'int',
    visible: false,
  },
  {
    colName: 'method',
    data: [{ method: 'get' }, { method: 'post' }],
    defaultValue: 'get',
    type: 'select',
    selectKeyName: 'method',
    selectPrimaryKey: 'method',
    validator: [{ name: 'required' }],
    visible: false,
  },
  {
    colName: 'is_active',
    selectKeyName: 'is_active',
    type: 'select',
    selectPrimaryKey: 'id',
    data: [
      { is_active: 'active', id: 'active' },
      { is_active: 'inactive', id: 'inactive' },
    ],
    validator: [{ name: 'required' }],
  },
];

export const EMAIL_TEMP_FORM: formBuilderData[] = [
  {
    colName: 'event_name',
    readonly: true,
    validator: [{ name: 'required' }],
  },
  {
    colName: 'id',
    visible: false,
    hidden: true,
    isPrimary: true,
  },
  {
    colName: 'smtp_profile_fk_id',
    title: 'SMTP',
    type: 'select',
    apiTblName: 'smtp_profile',
    selectKeyName: 'smtp_username',
    validator: [{ name: 'required' }],
  },
  { colName: 'from_name', validator: [{ name: 'required' }], hidden: true },
  {
    colName: 'from_email_id',
    validator: [{ name: 'required' }],
    info: 'It will show as sender on receiver end',
    hidden: true,
  },
  {
    colName: 'subject',
    validator: [{ name: 'required' }],
  },
  {
    colName: 'cc',
    visible: false,
    validator: [
      {
        name: 'pattern',
        funValue: VALIDATOR_PATTERNS.EMAIL,
        error: 'Cc should be valid',
      },
    ],
    type: 'chips',
  },
  {
    colName: 'bcc',
    visible: false,
    validator: [
      {
        name: 'pattern',
        funValue: VALIDATOR_PATTERNS.EMAIL,
        error: 'Bcc should be valid',
      },
    ],
    type: 'chips',
  },
  {
    colName: 'allow_to_send_email',
    selectKeyName: 'allow_email',
    type: 'checkbox',
    data: [{ allow_email: 'Yes', id: 1 }],
  },
  // { colName: 'created_at', colType:'DATE', visible:false,hidden:true },
];

export const MOBILE_FORM: formBuilderData[] = [
  {
    colName: 'mobile_appName',
    validator: [{ name: 'required' }],
  },
  {
    colName: 'version_number',
    title: 'Version',
    validator: [{ name: 'required' }],
  },
  {
    colName: 'id',
    visible: false,
    hidden: true,
    isPrimary: true,
  },
  {
    colName: 'type',
    title: 'App Type',
    type: 'select',
    selectKeyName: 'typeName',
    data: [
      { id: '1', typeName: 'android' },
      { id: '2', typeName: 'ios' },
    ],
    validator: [{ name: 'required' }],
  },
  {
    colName: 'category_id',
    title: 'Category',
    type: 'select',
    selectKeyName: 'categoryName',
    data: [
      { id: '1', categoryName: 'Staff App' },
      { id: '2', categoryName: 'Sponsor App' },
    ],
    validator: [{ name: 'required' }],
  },

  {
    colName: 'active_publish',
    title: 'Active Publish ?',
    type: 'checkbox',
    event: { name: 'change', isCallback: true },
    data: [{ name: 'Yes', id: 1 }],
    selectKeyName: 'name',
    selectPrimaryKey: 'id',
  },
  {
    colName: 'app_file',
    title: 'APP Build',
    type: 'FILE',
    fileConfig: { fileType: 'APP_BUILD' },
    visible: false,
    validator: [{ name: 'required' }],
  },
];

export const EXPORT_TEMPLATE_FORM: formBuilderData[] = [
  {
    colName: 'id',
    visible: false,
    hidden: true,
    isPrimary: true,
  },
  {
    colName: 'template_name',
    title: 'Template Name',
    col_size: 6,
    validator: [{ name: 'required' }],
  },
  {
    colName: 'module',
    title: 'Module',
    type: 'select',
    col_size: 6,
    data: Object.keys(MODULE_NAME).map((m) => ({ module: m, id: m.toLocaleLowerCase() })),
    selectKeyName: 'module',
    selectPrimaryKey: 'id',
    validator: [{ name: 'required' }],
  },
  {
    colName: 'code',
    title: 'Template Code',
    col_size: 6,
    info: 'Unique code used to reference this template. Letters, numbers, - and _ only.',
    validator: [
      { name: 'required' },
      {
        name: 'pattern',
        funValue: /^[a-z0-9\-_]+$/i,
        error: 'Only letters, numbers, hyphens and underscores are allowed',
      },
    ],
  },
  {
    colName: 'category',
    title: 'Category',
    col_size: 6,
  },
  {
    colName: 'scope',
    title: 'Scope',
    type: 'select',
    col_size: 4,
    data: [
      { name: 'System', id: 'SYSTEM' },
      { name: 'User', id: 'USER' },
    ],
    selectKeyName: 'name',
    selectPrimaryKey: 'id',
    defaultValue: 'SYSTEM',
  },
  {
    colName: 'visibility',
    title: 'Visibility',
    type: 'select',
    col_size: 4,
    data: [
      { name: 'Public', id: 'PUBLIC' },
      { name: 'Logged-in Users', id: 'LOGGED_IN' },
      { name: 'Direct (hidden from reports UI)', id: 'DIRECT' },
    ],
    selectKeyName: 'name',
    selectPrimaryKey: 'id',
    defaultValue: 'LOGGED_IN',
  },
  {
    colName: 'is_default',
    title: 'Default for Module?',
    type: 'checkbox',
    col_size: 4,
    data: [{ name: 'Yes', id: 1 }],
    selectKeyName: 'name',
    selectPrimaryKey: 'id',
  },
  {
    colName: 'provider_class',
    title: 'Data Provider',
    type: 'select',
    col_size: 6,
    visible: false,
    apiFunName: 'getExportTemplateProviderOptions',
    selectKeyName: 'name',
    selectPrimaryKey: 'id',
    info: 'Only used when a section in the layout below is configured with columns_mode: dynamic.',
    validator: [{ name: 'required' }],
  },
  {
    colName: 'permission',
    title: 'Permission (optional)',
    col_size: 6,
    placeholder: 'e.g. MANAGE_REPORT,VIEW_ALL',
    info: 'Comma-separated permission action names. Leave blank to allow every user with module access.',
  },
  {
    colName: 'filter_config',
    title: 'Filter Config (JSON, optional)',
    type: 'TEXTAREA',
    col_size: 6,
    visible: false,
    info: 'formBuilderData[] shown to the user before export, e.g. date range filters.',
  },
  {
    colName: 'dynamic_config',
    title: 'Dynamic Validators (JSON, optional)',
    type: 'TEXTAREA',
    col_size: 6,
    visible: false,
    info: 'formDynamicValidator[] for the filter form above.',
  },
  {
    colName: 'layout_config',
    title: 'Layout Config (JSON)',
    type: 'TEXTAREA',
    col_size: 12,
    visible: false,
    info: 'The sheet/section/column layout consumed by the export engine - see app/Libraries/ERPExport/README.md for the full schema.',
    validator: [{ name: 'required' }],
  },
];

export const EXPORT_TEMPLATE_LIST_COL: formBuilderData[] = formTransform(EXPORT_TEMPLATE_FORM, {
  remove: ['permission', 'filter_config', 'dynamic_config', 'layout_config'],
});
